import { render, staticRenderFns } from "./BannerSwipe.vue?vue&type=template&id=03bc4a7a&scoped=true"
import script from "./BannerSwipe.vue?vue&type=script&lang=js"
export * from "./BannerSwipe.vue?vue&type=script&lang=js"
import style0 from "./BannerSwipe.vue?vue&type=style&index=0&id=03bc4a7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bc4a7a",
  null
  
)

export default component.exports